import { Skeleton } from '@/shared/ui/Skeleton';
import styles from './InboxPage.module.css';

/** Shown while the Inbox chunk and its first query load. Mirrors the list's row rhythm. */
export function InboxSkeleton() {
  return (
    <div className={styles.container} aria-busy="true" aria-label="Loading messages">
      <div className={styles.header}>
        <Skeleton style={{ height: 32, width: 140 }} />
      </div>
      <div className={styles.layout}>
        <div className={styles.listPane}>
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className={styles.skeletonRow}>
              <Skeleton style={{ height: 40, width: 40, borderRadius: '50%' }} />
              <div className={styles.skeletonRowText}>
                <Skeleton style={{ height: 14, width: '40%' }} />
                <Skeleton style={{ height: 12, width: '80%' }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
